import {observable, action, computed, createTransformer, reaction, extendObservable} from "mobx";
import {http} from '../../../config/Constantes'
import * as axios from "axios";
import LoginService from "../../../services/LoginService";
import UsuarioService from "../../../services/UsuarioService";
import lscache from "lscache";
import {setCookie} from "../../../utils/security";
import _ from 'lodash'

export default class LoginStore {

    @observable usuario;
    @observable usuarioLogado;
    @observable senha;
    @observable nome;
    @observable mensagemErro;
    @observable logging;
    @observable loadingUsuarioLogado;
    @observable isLogado;

    constructor() {
        this.mensagemErro = "";
        this.nome = window.localStorage.getItem('loggedUserName');
        this.loginService = new LoginService();
        this.usuarioService = new UsuarioService();
        this.usuarioLogado = {};
        this.logging = false;
        this.getUsuarioLogado();
        this.isLogado = false;

        reaction(
            () => this.nome,
            nome => {
                if (nome) {
                    window.localStorage.setItem('loggedUserName', nome);
                } else {
                    window.localStorage.removeItem('loggedUserName');
                }
            }
        );
    }

    @computed
    get isAnalistaLogado() {
        return this.usuarioLogado && !this.usuarioLogado.perfilEtt && !this.usuarioLogado.perfilExecutivo && !this.usuarioLogado.perfilAdministrador;
    }

    @computed
    get isPerfilEttLogado() {
        return this.usuarioLogado && this.usuarioLogado.perfilEtt;
    }

    @computed
    get isSolicitanteMOTExcecao() {
        return this.isPerfilAdministradorLogado;
    }

    @computed
    get isPerfilAdministradorLogado() {
        return this.usuarioLogado && this.usuarioLogado.perfilAdministrador;
    }

    @computed
    get isPerfilAdministradorOuDCCHLogado() {
        return this.usuarioLogado && (this.usuarioLogado.perfilAdministrador || this.usuarioLogado.perfilDcch);
    }

    @computed
    get isPerfilRemuneracaoOuDCCH() {
        return this.usuarioLogado && (this.usuarioLogado.perfilRemuneracao || this.usuarioLogado.perfilDcch)
    }

    @computed
    get isPerfilAdministradorOuEtt() {
        return this.usuarioLogado && (this.usuarioLogado.perfilAdministrador || this.usuarioLogado.perfilEtt);
    }

    @computed
    get podeSolicitarMOT() {
        return this.usuarioLogado && (this.usuarioLogado.perfilAdministrador || this.usuarioLogado.perfilExecutivo || this.usuarioLogado.perfilSolicitanteMot);
    }

    @computed
    get possuiAlgumPerfil() {
        const usuario = this.usuarioLogado;
        return usuario && (usuario.perfilAdministrador || usuario.perfilDcch || usuario.perfilDnc || usuario.perfilEtt || usuario.perfilExecutivo || usuario.perfilRemuneracao || usuario.perfilRts || usuario.perfilSolicitanteMot || usuario.perfilAnalista)
    }

    @computed
    get isPerfilRtsLogado() {
        return this.usuarioLogado && this.usuarioLogado.perfilRts;
    }

    @computed
    get isPerfilRemuneracaoLogado() {
        return this.usuarioLogado && (this.usuarioLogado.perfilRemuneracao || this.usuarioLogado.perfilDcch)
    }

    @computed
    get isPermitidoGerarRelatorioFinanceiroOuTimesheetOuMotsAtivas() {
        return this.usuarioLogado && (this.usuarioLogado.perfilAdministrador || this.usuarioLogado.perfilRelatorioFinanceiro || this.usuarioLogado.perfilRelatorioTimesheet || this.usuarioLogado.perfilExecutivo || this.usuarioLogado.perfilRelatorioMOTsAtivas)
    }

    @computed
    get isPerfilAdministradorOuGestor() {
        return this.usuarioLogado && (this.usuarioLogado.perfilAdministrador || this.usuarioLogado.perfilExecutivo || this.usuarioLogado.perfilSolicitanteMot)
    }

    @computed
    get isPermitidoGerarRelatorioFinanceiro() {
        return this.usuarioLogado && (this.usuarioLogado.perfilAdministrador || this.usuarioLogado.perfilRelatorioFinanceiro || this.usuarioLogado.perfilExecutivo)
    }

    @computed
    get isPermitidoGerarRelatorioTimesheet() {
        return this.usuarioLogado && (this.usuarioLogado.perfilAdministrador || this.usuarioLogado.perfilRelatorioTimesheet || this.usuarioLogado.perfilExecutivo)
    }

    @computed
    get isPermitidoGerarRelatorioAtivas() {
        return this.usuarioLogado && (this.usuarioLogado.perfilAdministrador || this.usuarioLogado.perfilRelatorioMOTsAtivas)
    }

    //RHFPP-612 - Relatorio SIS MOT
    @computed
    get isPermitidoGerarRelatorioSisMot() {
        return this.usuarioLogado && (this.usuarioLogado.perfilAdministrador || this.usuarioLogado.perfilRelatorioSISMOT)
    }

	isDelegouUsuarioLogado(idSolicitante) {
        return this.usuarioLogado && (this.usuarioLogado.listaIdsUsuariosDelegaram.includes(idSolicitante))
    }

    isSolicitanteMotGestor(idGestorSolicitante){
        const solicitantes = _.get(this, "usuarioLogado.gestores", []);
        return solicitantes.some(sm => sm.id == idGestorSolicitante);
    }

    checkPermission(permission) {
        if ((typeof permission) === "object") {
            let retornos = false;
            permission.map((permissao) => {
                switch (permissao) {
                    case "administrador":
                        retornos = retornos || _.get(this, "usuarioLogado.perfilAdministrador", false);
                        break;
                    case "solicitar-mot":
                        retornos = retornos || this.podeSolicitarMOT;
                        break;
                    case "possui-perfil":
                        retornos = retornos || this.possuiAlgumPerfil;
                        break;
                    case "nao-ett":
                        retornos = retornos || !this.isPerfilEttLogado;
                        break;
                    case "ett":
                        retornos = retornos || this.isPerfilEttLogado;
                        break;
                    case "administrador-ou-dcch":
                        retornos = retornos || this.isPerfilAdministradorOuDCCHLogado;
                        break;
                    case "administrador-ou-ett":
                        retornos = retornos || this.isPerfilAdministradorOuEtt;
                        break;
                    case "remuneracao-ou-dcch":
                        retornos = retornos || this.isPerfilRemuneracaoOuDCCH;
                        break;
                    case "rts":
                        retornos = retornos || this.isPerfilRtsLogado;
                        break;
                    case "remuneracao":
                        retornos = retornos || this.isPerfilRemuneracaoLogado;
                        break;
                    case "administrador-ou-gestor":
                        retornos = retornos || this.isPerfilAdministradorOuGestor;
                        break;
                    case "administrador-ou-gestor-ou-relatorio-financeiro":
                        retornos = retornos || this.isPermitidoGerarRelatorioFinanceiro;
                        break;
                    case "administrador-ou-gestor-ou-permitido":
                        retornos = retornos || this.isPermitidoGerarRelatorioFinanceiroOuTimesheetOuMotsAtivas;
                        break;
                    case "administrador-ou-gestor-ou-relatorio-timesheet":
                        retornos = retornos || this.isPermitidoGerarRelatorioTimesheet;
                        break;
                    case "administrador-ou-relatorio-mots-ativas":
                        retornos = retornos || this.isPermitidoGerarRelatorioAtivas;
                        break;
                    //RHFPP-612 - Relatorio SIS MOT
                    case "administrador-ou-relatorio-sis-mot":
                        retornos = retornos || this.isPermitidoGerarRelatorioSisMot;
                        break;
                }
            });
            return retornos;

        } else {
            switch (permission) {
                case "administrador":
                    return _.get(this, "usuarioLogado.perfilAdministrador", false);
                case "solicitar-mot":
                    return this.podeSolicitarMOT;
                case "possui-perfil":
                    return this.possuiAlgumPerfil;
                case "nao-ett":
                    return !this.isPerfilEttLogado;
                case "ett":
                    return this.isPerfilEttLogado;
                case "administrador-ou-dcch":
                    return this.isPerfilAdministradorOuDCCHLogado;
                case "administrador-ou-ett":
                    return this.isPerfilAdministradorOuEtt;
                case "remuneracao-ou-dcch":
                    return this.isPerfilRemuneracaoOuDCCH;
                case "administrador-ou-gestor":
                    return this.isPerfilAdministradorOuGestor;
                case "rts":
                    return this.isPerfilRtsLogado;
                case "remuneracao":
                    return this.isPerfilRemuneracaoLogado;
                case "administrador-ou-gestor-ou-permitido":
                    return this.isPermitidoGerarRelatorioFinanceiro || this.isPermitidoGerarRelatorioAtivas;
                default:
                    if (typeof permission === "function") {
                        return permission(this);
                    } else {
                        return permission === undefined || permission === null;
                    }
            }
        }

    }

    getUsuarioLogado() {
        this.loadingUsuarioLogado = true;
        this.usuarioService.me().then(response => {
            if (response.data) {
                extendObservable(this.usuarioLogado, response.data);
                this.usuarioLogado = response.data;
            }
            this.loadingUsuarioLogado = false;
        }).catch(error => {
            console.log(error);
            this.loadingUsuarioLogado = false;
        });
    }

    setUsuario(value) {
        this.usuario = value;
    }

    setSenha(value) {
        this.senha = value;
    }

    login(e) {
        this.logging = true;
        e.preventDefault();
        this.mensagemErro = "";
        this.loginService.login(this.usuario, this.senha).then(response => {
            this.token = response.data.token;
            this.nome = response.data.nome;
            this.usuario = "";
            this.senha = "";
            this.mensagemErro = "";
            this.logging = false;
        }).catch(error => {
            console.log("Error -> " + JSON.stringify(error));
            this.mensagemErro = _.get(error, "response.data.message");
            this.logging = false;
        });
    }

}